import React from "react";
import styles from "./About.module.css";
import Skills from "./Skills";

const About = () => {
  return (
    <section className={styles.about_section} id="about">
      <div className={styles.heading}>
        <h2 className={styles["title"]}>About Me</h2>
      </div>
      <div className={styles.container}>
        <div className={styles.left}>
          <h3>Get to Know me!</h3>
          <p className={styles.desc}>
          I am a passionate full-stack developer with expertise in the MERN stack and a focus on building user-centric designs. With strong technical skills in HTML, CSS, JavaScript, React, Node, and more, I am dedicated to solving complex business problems with elegant technical solutions. Additionally, my soft skills in decision-making, teamwork, problem-solving, remote work, and online collaboration make me a valuable asset in any workplace.✨✨            
          </p>
          <p className={styles.desc}>
       
          </p>
        </div>
        <div className={styles.right}>
      
          
        </div>
      </div>
    </section>
  );
};

export default About;
